import { typeYfManagerEnum, typeYfManagerRequestEnum } from '../../enums/yfManagerEnums'
import { IntlShape } from 'react-intl'

const NUMERO_URGENCE = '112'

export const convertYfManagerData = (response: any, intl: IntlShape) => ({
    nom: response.numLoge ? response.numLoge : intl.formatMessage(
        {
            id: 'you_first_manager.defaultYfm',
            defaultMessage: 'Votre équipe YouFirst',
            description: 'YouFirst default name'
        }
    ),
    horaires: response.horaires,
    contact: response.contact,
    urgenceTech: response.urgenceTech,
    ascensoriste: response.ascensoriste,
    chauffagiste: response.chauffagiste,
    parking: response.parking,
    urgence: NUMERO_URGENCE,
    type: response.statut === typeYfManagerRequestEnum.couple ? typeYfManagerEnum.couple : typeYfManagerEnum.manager
})